var x = y => { var x = {}; __webpack_require__.d(x, y); return x; }
var y = x => () => x
const __WEBPACK_NAMESPACE_OBJECT__ = x({ ["addHook"]: () => __WEBPACK_EXTERNAL_MODULE_dompurify__.addHook, ["sanitize"]: () => __WEBPACK_EXTERNAL_MODULE_dompurify__.sanitize });